import { FETCH_PROJECTS } from '../constants/actionTypes'

export default (state = [], action) => {
  switch(action.type) {
    case FETCH_PROJECTS : 
      return ({...state}, action.payload);
    default : 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/projectsReducer.js